import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Bandcamp = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 25 25'
  >
    <path
      d='M14.917 16.455H5.835l4.224-7.861h9.155l-4.297 7.861z'
      fill={ color }
    />
    <circle
      cx={ 12.5 }
      cy={ 12.5 }
      fill='none'
      r={ 12 }
      stroke={ color }
    />
  </svg>
);

Bandcamp.propTypes = { ...iconPropTypes };

Bandcamp.defaultProps = { ...iconDefaultProps };

export default Bandcamp;